export default {
  ENABLE_LOCAL_MODE: 'enableLocalMode',
  SET_PUSHING_STATUS: 'setPushingStatus',
  SET_IS_RECONNECTING: 'setIsReconnecting',
};
